export function ieCheck(){
    //Checks IE 6 - 11 and Edge
    const ua = window.navigator.userAgent;
    return (ua.indexOf('MSIE') !== -1 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0) ? true : false;
}

//Converts times into minutes/hours/days
export function timeConverter(time){

    if(time <= 120){
        return `${time} minutes`;
    }
    if(time > 120 && time < 1440){
        const hours = time / 60;
        const minutes = time % 60;
        return `${Math.floor(hours)} hours and ${Math.floor(minutes)} minutes`;
    }
    if(time > 1440){
        const day = time / 1440;
        return `${Math.floor(day)} days`;   
    }
}

//Converts 24 to ampm
export function ampmConvert(timeString){
    try{
        var hourEnd = timeString.indexOf(":");
        var H = +timeString.substr(0, hourEnd);
        var h = H % 12 || 12;
        var ampm = H < 12 ? "AM" : "PM";
        return h + timeString.substr(hourEnd, 3) + ampm;
    }
    catch(e){
        return "";
    }
}


export function isLocalHost(){
    const host = window.location.host;
    return (host.substring(0, host.indexOf(':')) !== 'localhost') ? false : true;
}